//export const BASE_URL = 'http://localhost:8000/';

export const BASE_URL = 'https://yugmantraa.com/api/';
// export const BASE_URL = 'https://siddharthfashion.in/api/';

export const RAZORPAY_TEST_KEY_ID = 'rzp_test_RZdbQNoVtXjjiM';
export const RAZORPAY_LIVE_KEY_ID = 'rzp_live_TGvEvIlTzEysJV';
// export const RAZORPAY_LIVE_KEY_ID = 'rzp_live_RZdA14OB2rhQoW';
